import { useTranslation } from 'react-i18next'
import { useNetworkStatus } from '@/shared/hooks'

export function GroceryListSyncBanner() {
  const { t } = useTranslation('grocery-list')
  const { isOnline } = useNetworkStatus()

  if (isOnline) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-amber-50 border-b border-amber-200 px-4 py-2 text-sm text-amber-800"
    >
      {t('offlineBanner')}
    </div>
  )
}
